import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import i18next from 'i18next';

const useStyles = makeStyles((theme) => ({
  message: {
    color: theme.palette.warning.main,
  },
}));

export const WarningMessage = ({
  message,
  namespace = 'translations',
  translate = true,
  ...props
}) => {
  const { t } = useTranslation(['translations', 'errors']);
  const classes = useStyles();
  return (
    <Typography
      role="alert"
      aria-live="assertive"
      className={classes.message}
      variant="body2"
      {...props}
    >
      {translate ? t(message, { ns: namespace, lng: i18next.language }) : message}
    </Typography>
  );
};
